import React from "react";
import { useAiContext } from "../../ai/AiContext";

export function AIPlaceholderButton(props: {
  type?: string;
  disabled?: boolean;
  onClick?: () => void | Promise<void>;
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}) {
  const {
    type = "summary",
    disabled,
    onClick,
    children,
    className,
    style,
  } = props;

  const { setAiOpen } = useAiContext();

  const handleClick = async () => {
    if (disabled) return;
    if (onClick) {
      await onClick();
      return;
    }
    setAiOpen(true);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={disabled}
      className={
        className ||
        "inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-purple-600 hover:bg-purple-500 text-white text-sm shadow disabled:opacity-50"
      }
      style={style}
      aria-label={`AI ${type}`}
      title={`AI ${type}`}
    >
      <span className="text-lg">✨</span>
      <span>{children || "AI 分析"}</span>
    </button>
  );
}

export default AIPlaceholderButton;
